export default "__VITE_ASSET__CqN3cb1Z__"